import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconOpenInNewLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.701 20c-.475 0-.877-.165-1.207-.494A1.642 1.642 0 0 1 4 18.299V5.7c0-.475.165-.877.494-1.207.33-.33.732-.494 1.207-.494h5.231c.2 0 .368.068.503.203a.683.683 0 0 1 .203.503c0 .2-.068.368-.203.503a.683.683 0 0 1-.503.203h-5.23a.276.276 0 0 0-.2.09.276.276 0 0 0-.09.2v12.597c0 .072.03.138.09.199.06.06.127.09.2.09h12.597c.072 0 .138-.03.199-.09.06-.06.09-.127.09-.2v-5.23c0-.2.068-.368.203-.503a.683.683 0 0 1 .503-.203c.2 0 .368.068.503.203a.683.683 0 0 1 .203.503v5.23c0 .476-.165.879-.494 1.208-.33.33-.732.494-1.207.494H5.7ZM18.588 6.404l-8.239 8.239a.683.683 0 0 1-.491.2.666.666 0 0 1-.5-.2.676.676 0 0 1-.205-.496c0-.195.068-.36.204-.496l8.24-8.24h-3.009a.682.682 0 0 1-.503-.202.683.683 0 0 1-.203-.503c0-.2.068-.368.203-.503A.682.682 0 0 1 14.588 4h4.561a.82.82 0 0 1 .607.244.824.824 0 0 1 .244.606v4.56a.685.685 0 0 1-.203.504.683.683 0 0 1-.503.203.683.683 0 0 1-.503-.203.682.682 0 0 1-.203-.503V6.404Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconOpenInNewLine;
